export const loadData = async (fields, preparedValues, loadData) => {
    if (preparedValues && Object.keys(preparedValues).length > 0) {
      loadData(preparedValues);
    } else {
      loadData();
    }
}